import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment'
import { UserToken } from '../shared/models/users/user-token';
import { UserTokenResult } from '../shared/models/users/user-token-result';

@Injectable({
  providedIn: 'root'
})
export class SsoService {
  env = environment;
  apiUrl = this.env.apiurl + 'platform/sso/';

  constructor(private http: HttpClient, public router: Router) {}

  
  public IsValidAuthToken(token: string, tokenExpiry: string, userId: number): Observable<boolean> {
    const tokenUser: UserToken = {
      token,
      tokenExpiry: this.toApiTokenExpiry(tokenExpiry),
      userId,
      otp: null,
      redirectUrl: null,
    };

    return this.http.post<boolean>(`${this.apiUrl}validate-authtoken`, tokenUser);
  }

  private toApiTokenExpiry(tokenExpiry: string): string {
    const expiryUnix = Number(tokenExpiry);
    if (!Number.isNaN(expiryUnix) && expiryUnix > 1_000_000_000) {
      return new Date(expiryUnix * 1000).toISOString();
    }
    return tokenExpiry;
  }


  public RecheckUser(tokenUser: UserToken): Observable<UserTokenResult> {
    return this.http.post<UserTokenResult>(`${this.apiUrl}recheck`, tokenUser);
  }
}